import apihost from './ApiHost.js';
import {getCookie} from './CookieFunctions.js';
async function JWT_VAl() {
    const JWT =getCookie("_JWT");
      if (JWT) {
        try {
          const r = await fetch(`${apihost}/JWT`, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${JWT}`,
            },
          });
          const d = await r.json();
          if (d.success && d.verified) {
            return {success:true,verified:true};
          }
          if (d.success && !d.verified) {
            return {success:true,verified:false};
          }
        } catch (error) {
           return {success:false,verified:false};
        }
      }else{
        return {success:false,verified:false};
      }
}

export {JWT_VAl};